import { Form } from "@redriver/cinnamon-mui";
import { getAgencies } from "./actions";

const AgencyTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getAgencies} />
);

export default AgencyTypeAhead;
